"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseISOTimeSafe = exports.formatISOTime = exports.parseISOTime = exports.parseISOSafe = void 0;
const date_fns_1 = require("date-fns");
function parseISOSafe(date) {
    if (date == null) {
        return date;
    }
    else {
        return (0, date_fns_1.parseISO)(date);
    }
}
exports.parseISOSafe = parseISOSafe;
function parseISOTime(time) {
    const now = new Date();
    const dateTime = (0, date_fns_1.formatISO)(now, { representation: 'date' }) + 'T' + time;
    return (0, date_fns_1.parseISO)(dateTime);
}
exports.parseISOTime = parseISOTime;
function formatISOTime(date, withSeconds = false) {
    const time = (0, date_fns_1.formatISO)(date, { representation: 'time' });
    if (time.endsWith('Z')) {
        const timeWithoutZ = time.slice(0, -1);
        if (withSeconds) {
            return timeWithoutZ;
        }
        else {
            return timeWithoutZ.slice(0, -3);
        }
    }
    else if (time.includes('+')) {
        const timeWithoutZ = time.slice(0, time.indexOf('+'));
        if (withSeconds) {
            return timeWithoutZ;
        }
        else {
            return timeWithoutZ.slice(0, -3);
        }
    }
    else if (time.includes('-')) {
        const timeWithoutZ = time.slice(0, time.indexOf('-'));
        if (withSeconds) {
            return timeWithoutZ;
        }
        else {
            return timeWithoutZ.slice(0, -3);
        }
    }
    else {
        return time;
    }
}
exports.formatISOTime = formatISOTime;
function parseISOTimeSafe(date) {
    if (date == null) {
        return date;
    }
    else {
        return parseISOTime(date);
    }
}
exports.parseISOTimeSafe = parseISOTimeSafe;
//# sourceMappingURL=date-utils.js.map